<script>
  export default {
    name: 'navigation-item-icon',

    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <i v-if="item.icon" class="item-icon">
    <font-awesome-icon :icon="['far', item.icon]"/>
  </i>
</template>
